import { gql } from "@apollo/client";

export const getDogsByIdQuery = gql`
  query GetAllRegisteredDogsByAuthId($authId: String!) {
    getAllRegisteredDogsByAuthId(authId: $authId) {
      id
      dog_id
      call_name
      registration_name
      breed
      breed_mix
      gender
      authId
      dogImage
      rescue
      date_of_birth
      payment_status
      notes
    }
  }
`;

export const getDogsQuery = gql`
  query getMyRegisteredDogs {
    getMyRegisteredDogs {
      id
      call_name
      registration_name
      breed
      breed_mix
      gender
      authId
      rescue
      date_of_birth
      dogImage
      payment_status
      dog_id
      noviceLevel
      status
    }
  }
`;

export const addPayment = gql`
  mutation ($data: MakePaymentInput!) {
    registerPayment(data: $data) {
      success
      data {
        id
        intent
        state
        payer {
          payment_method
        }
        transactions {
          amount {
            total
            currency
          }
        }
        create_time
        links {
          href
          rel
          method
        }
      }
    }
  }
`;

export const updateRegisteredDogs = gql`
  mutation updateMyRegisteredDog($data: [UpdateDogsInput!]!) {
    updateMyRegisteredDog(data: $data) {
      id
      call_name
      registration_name
      breed
      breed_mix
      gender
      authId
      rescue
      date_of_birth
    }
  }
`;

export const GET_REGISTERED_DOGS = gql`
  query getMyRegisteredDogsTrial {
    getMyRegisteredDogsTrial {
      id
      dog
      division
      elements
      authId
    }
  }
`;

export const REGISTER_DOG_FOR_FREE = gql`
  mutation RegisterDogForFree($data: [CreateDogInput!]!) {
    registerDogForFree(data: $data) {
      success
      message
      data {
        id
        call_name
        registration_name
        breed
        breed_mix
        gender
        authId
        dogImage
        rescue
        date_of_birth
        paymentId
        titleDate
        title
        qs
        status
        payment_status
        dogLegs
      }
    }
  }
`;

export const getRegisteredDogSITByIdQuery = gql`
  query GetRegisteredDogSITById($dogId: Int!) {
    getRegisteredDogSITById(dogId: $dogId) {
      id
      birch
      anise
      clove
    }
  }
`;

export const getAllSummaryQuery = gql`
  query GetAllSummary($dogId: Int!, $summaryType: String!) {
    getAllSummary(dogId: $dogId, summaryType: $summaryType) {
      id
      search
      count
    }
  }
`;

export const getAllPremierAndNonPremierResultQuery = gql`
  query GetAllPremierAndNonPremierResult(
    $pageNumber: Int!
    $pageSize: Int!
    $dogId: Int!
    $search: String!
  ) {
    getAllPremierAndNonPremierResult(
      pageNumber: $pageNumber
      pageSize: $pageSize
      dogId: $dogId
      search: $search
    ) {
      pageNumber
      pageSize
      totalDocs
      totalPages
      totalCount
      data {
         id
            dogId
            date
            search
            handler
            dog
            breed
            div
            qNq
            ngReason
            time
            hidesFound
            faults
            faultReason
            points
            place
            timeLimit
            hidesSet
            judgeNotes
            searchName
            trialCalendarId
            trialLocation
            hide1Location
            hide1Found
            hide2Location
            hide2Found
            hide3Location
            hide3Found
            hide4Location
            hide4Found
            hide5Location
            hide5Found
            hide6Location
            hide6Found
            hide7Location
            hide7Found
            breed_mix
      }
    }
  }
`;

export const getAllTitlesDashboardQuery = gql`
  query GetAllTitlesDashboard($dogId: Int!) {
    getAllTitlesDashboard(dogId: $dogId) {
      noOfTitles
      noofTrialEarned
      noOfQualification
      dog {
        id
        registration_name
        call_name
        breed
        date_of_birth
        breed_mix
        gender
        rescue
        authId
        status
        payment_status
        notes
        dogImage
        noviceLevel
      }
    }
  }
`;

export const updateDogNotesMutation = gql`
  mutation UpdateDogNotes($dogId: Int!, $notes: String!) {
    updateDogNotes(dogId: $dogId, notes: $notes) {
      message
    }
  }
`;

export const getAllTitlesEarnedQuery = gql`
  query GetAllTitlesEarned($pageNumber: Int!, $pageSize: Int!, $dogId: Int!) {
    getAllTitlesEarned(
      pageNumber: $pageNumber
      pageSize: $pageSize
      dogId: $dogId
    ) {
      pageNumber
      pageSize
      totalDocs
      totalPages
      totalCount
     data {
        titleEarned {
          search
          shortName
          count
          date
        }
        shortName
        type
        date
      }
    }
  }
`;

export const GetMyRegisteredUnpaidDogs = gql`
  query getMyRegisteredUnpaidDogs {
    getMyRegisteredUnpaidDogs {
      id
      call_name
      registration_name
      breed
      breed_mix
      gender
      authId
      dogImage
      rescue
      date_of_birth
      payment_status
    }
  }
`;

export const MakePendingDogPayments = gql`
  mutation makePendingDogPayment($amount: Int!) {
    makePendingDogPayment(
      data: { amount: $amount, currency: "USD", payment_method: "Paypal" }
    ) {
      success
      data {
        id
        intent
        state
        create_time
        payer {
          payment_method
        }
        transactions {
          amount {
            total
            currency
          }
        }
        links {
          href
          rel
          method
        }
      }
    }
  }
`;

export const DogRegistrationStatusUpdate = gql`
  mutation UpdateRegisteredDogStatus($id: Int!, $status: String!) {
    updateRegisteredDogStatus(id: $id, status: $status) {
      message
    }
  }
`;

export const getAllTrialIndividualDogHistory = gql`
  query GetAllTrialIndividualDogHistory(
    $pageNumber: Int
    $pageSize: Int
    $dogId: Int!
    $date: String
    $location: String
  ) {
    getAllTrialIndividualDogHistory(
      pageNumber: $pageNumber
      pageSize: $pageSize
      dogId: $dogId
      date: $date
      location: $location
    ) {
      pageNumber
      pageSize
      totalDocs
      totalPages
      totalCount
      data {
        id
        dogId
        date
        earnedPoints
        totalPoints
        trialLocation
      }
    }
  }
`;

export const updateTrialzEarnedDate = gql`
  mutation UpdateTrialzEarnedDate($dogId: Int!, $shortName: String!, $search: String!, $date: DateTime!, $summaryType: String) {
    updateTrialzEarnedDate(dogId: $dogId, shortName: $shortName search: $search, date: $date, summaryType: $summaryType) {
      message
    }
  }
`;

export const addManualQ = gql`
  mutation AddManualQ($dogId: Int!, $search: String!, $summaryType: String!, $date: DateTime!) {
    addManualQ(dogId: $dogId, search: $search, summaryType: $summaryType, date: $date) {
      success
      message
      currentCount
      milestoneReached
      qDate
    }
  }
`;

export const removeManualQ = gql`
  mutation RemoveManualQ($dogId: Int!, $search: String!, $summaryType: String!) {
    removeManualQ(dogId: $dogId, search: $search, summaryType: $summaryType) {
      success
      message
      currentCount
      milestoneRemoved
      removedTitleShortName
    }
  }
`;

export const updateSummaryCount = gql`
  mutation UpdateSummaryCount($id: String!, $count: Int!) {
    updateSummaryCount(id: $id, count: $count) {
      message
    }
  }
`;

export const updateSummaryCount1 = gql`
  mutation UpdateSummaryCount($id: String!, $search: String!, $dogId: Int!, $summaryType: String!, $count: Int!) {
    updateSummaryCount(id: $id, dogId: $dogId, search: $search, summaryType: $summaryType, count: $count) {
      message
    }
  }
`;

export const passDogNoviceLevel = gql`
  mutation PassDogNoviceLevel($dogId: Int!) {
    passDogNoviceLevel(dogId: $dogId,) {
      message
    }
  }
`;

export const checkForAlreadyRequestQuery = gql`
  query CheckForAlreadyRequest($dogId: Int!, $division: String!, $elements: String!, $trialCalendarId: Int!) {
    checkForAlreadyRequest(
      data: {
        dogId: $dogId
        division: $division
        elements: $elements
        trialCalendarId: $trialCalendarId
      }
    ) {
      message
    }
  }
`;
